import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';

import Switch from 'react-switch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardBody, Row, Col, List, Collapse, Label, Spinner } from 'reactstrap';
import BZAPIService from '../../../services/BZAPIService';
import { toast } from 'react-toastify';
import LoaderButton from '../../loader-button/LoaderButton';

const getContentClassNames = color => {
  const contentClassNames = 'display-12 fs-12 mb-12 font-weight-normal text-sans-serif';
  return contentClassNames;
};

const CardSummary = ({
  title,
  to,
  color,
  children,
  message,
  activeTab,
  setActiveTab,
  errors,
  vendorId,
  isConfigured,
  loadServices,
  loading,
  isServiceActive,
  setIsServiceActive
}) => {
  let icon = 'exclamation';
  switch (color) {
    case 'green':
      icon = 'check';

      break;
    case 'light-blue':
      icon = 'clock';

      break;
    case 'blue':
      icon = 'exclamation';

      break;

    default:
      break;
  }

  const [active, setActive] = useState('');
  // const [isServiceActive, setIsServiceActive] = useState();
  const [isLoadingService, setIsLoadingService] = useState(false);
  const errorCodes = [
    {
      id: 'H001',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H001---Vendor-API-Request-Error'
    },
    {
      id: 'H002',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H002---Vendor-API-Auth-Token-Generation-Error'
    },
    {
      id: 'H003',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H003---Vendor-API-Error'
    },
    {
      id: 'H004',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H004---Vendor-API-Error'
    },
    {
      id: 'H005',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H005---Vendor-Public-API-Error'
    },
    {
      id: 'H006',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-api-errors#H006---Vendor-API-Error-Threshold-Exceeded'
    },
    {
      id: 'OP001',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP001---Integration-Not-Configured'
    },
    {
      id: 'OP002',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP002---Vendor-Integration-Disabled'
    },
    {
      id: 'OP003',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP003---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP004',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP004---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP005',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP005---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP006',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors#OP006---Vendor-Credentials-Configuration-Error'
    },
    {
      id: 'OP007',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP007---Incompatible-ServiceNow-CI'
    },
    {
      id: 'OP008',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP008---ServiceNow-API-Request-Error'
    },
    {
      id: 'OP009',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP009---Vendor-Cloud-Health-Error'
    },
    {
      id: 'OP010',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP010---Vendor-Cloud-Inventory-Access-Error'
    },
    {
      id: 'OP011',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP011---Vendor-Subscription-Enrollment-Error'
    },
    {
      id: 'OP012',
      href:
        '/documentation/user-guides/bugzero-dashboard-error-codes-servicenow-cloud-inventory-errors#OP012---ServiceNow-Connection-Error'
    },
    {
      id: 'P001',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-bugzero-api-errors#P001---BugZero-API-Error'
    },
    {
      id: 'P002',
      href: '/documentation/user-guides/bugzero-dashboard-error-codes-bugzero-api-errors#P002---BugZero-API-Error'
    }
  ];

  async function setService(e) {
    setIsLoadingService(true);
    try {
      const res = await BZAPIService.setStatus(vendorId, e === true ? 1 : 0);
      setIsServiceActive(res?.data?.concurrency);
      toast.success(`Bug service has been ${e ? 'enabled' : 'disabled'}`);
      setIsLoadingService(false);
    } catch (err) {
      console.log(err);
      setIsLoadingService(false);
      toast.error(`Failed to ${e ? 'enable' : 'disable'} service`);
    }
  }

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
    console.log('tab', activeTab);
  };
  const toggleErrors = (e, to) => {
    e.preventDefault();
    active === to ? setActive('') : setActive(to);
  };
  return (
    <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem' }}>
      {/* <Background className={`bg-card`} /> */}
      <CardBody className="position-relative">
        <Row>
          <Col className="d-inline-flex flex-row text-left">
            <p className={`branding-${color} small`}>
              <span className={`${loading ? 'loading-skeleton' : ' '} `} data-testid={'service-status'}>
                {title}
              </span>
            </p>
            <p className="small">
              <span className={`fa-stack fa-xs ml-1 ${loading ? 'loading-skeleton' : ''}`}>
                <FontAwesomeIcon
                  icon="circle"
                  className={`${loading ? 'loading-skeleton' : `branding-${color} fa-stack-2x`}`}
                />
                <FontAwesomeIcon icon={icon} className={`${loading ? 'loading-skeleton' : 'fa-stack-1x'}`} inverse />
              </span>
            </p>
          </Col>
          <Col>
            <div className="text-right mb-auto">
              {isLoadingService ? <Spinner size={'sm'} /> : <></>}
              <Label className="mx-2 mb-2">Disable/Enable bug service</Label>
              <Switch
                onChange={e => setService(e)}
                checked={isServiceActive === 1 ? true : false}
                onColor="#253746"
                uncheckedIcon={false}
                height={14}
                width={28}
                disabled={!isConfigured}
              />
            </div>
          </Col>
        </Row>
        <Row>
          {' '}
          <Col className="text-right">
            <LoaderButton onClick={() => loadServices()} isLoading={loading} color="falcon-danger" size="sm">
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                <path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z" />
              </svg>
            </LoaderButton>
          </Col>
        </Row>
        {/* <Row>
          {' '}
          <Col className="text-right">
            {title === 'RUNNING' ? (
              <p className="small">
                Service started{' '}
                {timestamp
                  ? moment
                      .utc(timestamp)
                      .local()
                      .fromNow()
                  : 'Pending...'}
                .
              </p>
            ) : (
              <></>
            )}
          </Col>
        </Row> */}
        <Row>
          {' '}
          <Col className={getContentClassNames(color)}>
            <h6>{children}</h6>
            {title === 'NOT CONFIGURED' ? (
              // <div className="col">
              <Button
                color="falcon-default"
                onClick={e => toggleTab('3')}
                className="btn btn-falcon-default mt-2"
                size="sm"
                data-testid={'configure-btn'}
              >
                Configure
              </Button>
            ) : title === 'PENDING' ? (
              // <div className="col">
              <p>Service is running but data is not ready to be displayed yet</p>
            ) : (
              <>
                <div data-testid={'service-message'}>{message}</div>
                {errors?.length ? (
                  <div className="active mt-2">
                    {active === to ? <FontAwesomeIcon icon={'caret-down'} /> : <FontAwesomeIcon icon={'caret-right'} />}
                    <a
                      href="/"
                      className="nav-link-text active ml-1"
                      onClick={e => toggleErrors(e, to)}
                      style={{ marginBottom: '1rem' }}
                    >
                      more info
                    </a>
                    {/* <Collapse isOpen={e.label === active ? true : false}> */}

                    <Collapse isOpen={active === to ? true : false}>
                      <List type="unstyled">
                        {errors.map(e => (
                          <li key={e.label} className="active">
                            <a
                              href={`${
                                errorCodes.find(err => err.id.toLowerCase() === e.label.toLowerCase()) !== undefined
                                  ? errorCodes.find(err => err.id.toLowerCase() === e.label.toLowerCase())?.href
                                  : '/documentation/user-guides/bugzero-dashboard-error-codes-vendor-integration-errors'
                              }`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <small className="active">
                                {e.label} - {e.value}
                              </small>
                            </a>
                          </li>
                        ))}
                      </List>
                    </Collapse>
                  </div>
                ) : (
                  ''
                )}
              </>
            )}
          </Col>
          {/* <Col className="d-flex">
            <div className="mt-auto ml-auto mr-1">
              <Label className="ml-auto mr-1 mb-2">Disable/Enable bug service</Label>
              <Switch
                onChange={e => setService(e)}
                checked={isServiceActive === 1 ? true : false}
                onColor="#253746"
                uncheckedIcon={false}
                height={14}
                width={28}
              />
            </div>
          </Col> */}
        </Row>
      </CardBody>
    </Card>
  );
};

CardSummary.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  rate: PropTypes.string,
  linkText: PropTypes.string,
  to: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  errors: PropTypes.array,
  timestamp: PropTypes.string,
  vendorId: PropTypes.string,
  isConfigured: PropTypes.bool,
  loadServices: PropTypes.func,
  loading: PropTypes.bool,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number
};

export default CardSummary;
